import { Button, Center, Skeleton } from '@chakra-ui/react';
import { CustomButton } from '@Modules/core/components';
import { createColumnHelper } from '@tanstack/react-table';
import CustomDataTableEditBtn from '@Modules/core/components/table/CustomDataTableEditBtn';
import CustomDataTableInfoBtn from '@Modules/core/components/table/CustomDataTableInfoBtn';

import AuthorizationsConsultationDatatableRowMeta from "@Modules/admin/archiving/containers/mixedHandlers/archivedTables/authorizationsConsultation/AuthorizationsConsultationDatatableRowMeta";

export type TAuthorizationsConsultationDataTableData = {
    primaryKey: string | number,
    oneDate: string,
    authorizationNumber: string,
    PAN: string,
    dateExp: string,
    amount: string,
    mon: string,
    repo: string,
    status: string,
    statA: string,

    [x: string]: any,
};

type Props = {
  isLoading: boolean | undefined,
  handleEdit: (row: any) => void,
  displayDetails: (row: any) => void,
};

const columnHelper = createColumnHelper<TAuthorizationsConsultationDataTableData>()

export function getAuthorizationsConsultationDataTableColumns({ isLoading, handleEdit, displayDetails }: Props) {
  
  return [
    columnHelper.accessor("oneDate",
        {
            id: "oneDateId",
            header: "Date",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    {props.getValue()}
                </Skeleton>)
            },
        }
    ),
    columnHelper.accessor("authorizationNumber",
        {
            id: "authorizationNumberId",
            header: "N° Autorisation",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    {props.getValue()}
                </Skeleton>)
            },
        }
    ),
    columnHelper.accessor("PAN",
        {
            id: "PANId",
            header: "PAN",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    {props.getValue()}
                </Skeleton>)
            },
        }
    ),
    columnHelper.accessor("dateExp",
        {
            id: "dateExpId",
            header: "Date Exp.",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    {props.getValue()}
                </Skeleton>)
            },
        }
    ),
    columnHelper.accessor("amount",
        {
            id: "amountId",
            header: "Montant",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    {props.getValue()}
                </Skeleton>)
            },
        }
    ),
    columnHelper.accessor("mon",
        {
            id: "monId",
            header: "Mon.",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    {props.getValue()}
                </Skeleton>)
            },
        }
    ),
    columnHelper.accessor("repo",
        {
            id: "repoId",
            header: "Répo.",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    {props.getValue()}
                </Skeleton>)
            },
        }
    ),
    columnHelper.accessor("status",
        {
            id: "statusId",
            header: "Statut",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    {props.getValue()}
                </Skeleton>)
            },
        }
    ),
    columnHelper.accessor("statA",
        {
            id: "statAId",
            header: "Stat. A.",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    {props.getValue()}
                </Skeleton>)
            },
        }
    ),

       
    columnHelper.display(
        {
            id: "action",
            header: "",
            cell: props => {
                return (
                    <Skeleton isLoaded={!isLoading}>
                        <Center>
                        <CustomDataTableInfoBtn disabled={isLoading} onClick={() => displayDetails(props.row)} />
                        <CustomButton
                            size={'sm'}
                            onClick={() => handleEdit(props.row)}
                            ml={'10px'}
                        >
                            Autorisations
                        </CustomButton>
                        </Center>
                    </Skeleton>
                );
            }
        }

    ),
  ];
}
